var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:{
    'tile-btn': true,
    'tile-btn--mobile': _vm.isMobile,
    'tile-btn--shadow': !_vm.depressed,
    'tile-btn--square': _vm.square
  },attrs:{"id":_vm.id || _vm.title || undefined,"color":_vm.color,"depressed":_vm.depressed,"disabled":_vm.disabled || _vm.loading,"loading":_vm.loading,"block":"","text":"","tile":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"tile-btn__wrapper"},[_c(_vm.icon,{tag:"component",staticClass:"tile-btn__icon",style:(_vm.disabled ? 'fill: rgba(0,0,0,0.26)' : null)}),_vm._v(" "+_vm._s(_vm.$te(_vm.title) ? _vm.$t(_vm.title) : _vm.title)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }